import React from "react";
import Link from "gatsby-link";

import { rhythm, scale } from "../utils/typography";

class Template extends React.Component {
  render() {
    const { location, children } = this.props;
    let header;

    let rootPath = `/`;
    if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
      rootPath = __PATH_PREFIX__ + `/`;
    }

    if (location.pathname === rootPath) {
      header = (
        <h1
          style={{
            ...scale(1.5),
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: "none",
              textDecoration: "none",
              color: "inherit",
            }}
            to={"/"}
          >
            The Mitchell Tesla Kansas Trip Blog
          </Link>
        </h1>
      );
    } else {
      header = (
        <div>
          <Link
            style={{
              boxShadow: "none",
              textDecoration: "none",
              color: "inherit",
            }}
            to={"/"}
          >
            <h3
              style={{
                fontFamily: "Montserrat, sans-serif",
                marginTop: 0,
                marginBottom: 0,
              }}
            >
              The Mitchell Tesla Kansas Trip Blog
            </h3>
            &lt; back
          </Link>
        </div>
      );
    }
    return (
      <div
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: rhythm(24),
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        }}
      >
        {header}
        {children()}
      </div>
    );
  }
}

export default Template;



// WEBPACK FOOTER //
// ./src/layouts/index.js